export interface LayoutDetails {
    default: Layout;
    layouts: Layout[];
}

export enum Layout {
    'ONE_COLUMN' = 'one-col',
    'TWO_COLUMN' = 'two-col',
    'FOUR_COLUMN' = 'four-col',
    'SIX_COLUMN' = 'six-col',
    'EIGHT_COLUMN' = 'eight-col',
}
